import { render, staticRenderFns } from "./TileInProgressDowntime.vue?vue&type=template&id=87f027ba"
import script from "./TileInProgressDowntime.vue?vue&type=script&lang=js"
export * from "./TileInProgressDowntime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports